module.exports = __webpack_public_path__ + "static/media/startup-video-img.c83dc045.jpg";